<template>
<div>
    <v-autocomplete :items="instituicoes" :color="$primary" :disabled="!$_HASPERMISSION('PickerInstituicao', getSession.user.id_tipo_utilizador) || instituicoes.length==1" v-model="getSession.instituicao" @change="change()" item-text="nome" item-value="id_instituicao"></v-autocomplete>
</div>
</template>
<script>
export default {
    data: () => ({
    }),
    computed: {
        instituicoes() {
            return this.$store.getters['instituicao/getAll'];
        },
        getSession() {
            return this.$store.getters['session/getState']
        },
    },
    methods: {
        change() {
           this.$eventBus.$emit('ChangePickerInstituicao');
        }
    },
}
</script>
